import { Box, type BoxProps } from "@saleor/macaw-ui-next";
import type * as React from "react";

import { topBarHeight, topBarHeightSubtitle, topBarHeightSubtitleTop } from "../consts";

export const TopNavWrapper = ({
  children,
  withoutBorder,
  hasSubtitle,
  hasSubtitleTop,
  ...props
}: {
  children?: React.ReactNode;
  withoutBorder?: boolean;
  hasSubtitle?: boolean;
  hasSubtitleTop?: boolean;
} & BoxProps) => {
  const getHeight = () => {
    if (hasSubtitle) {
      return topBarHeightSubtitle;
    }

    if (hasSubtitleTop) {
      return topBarHeightSubtitleTop;
    }

    return topBarHeight;
  };

  return (
    <Box
      display={hasSubtitle || hasSubtitleTop ? "block" : "flex"}
      alignItems="center"
      paddingX={6}
      // 20px -> 8px. topBarHeight 를 56px 로 줄이면서 같이 낮춘다. (2026-09-17 KST 수정)
      paddingY={2}
      borderBottomWidth={withoutBorder ? 0 : 1}
      borderBottomStyle="solid"
      borderColor="default1"
      position="relative"
      data-test-id="page-header"
      __height={getHeight()}
      gridColumn="8"
      gridRowStart="1"
      // 기본은 불투명 흰 띠. 홈·설정·메시지는 바탕이 default1 을 반투명으로 내려보내서
      // 이 줄이 저절로 유리가 된다. (2026-09-23 KST 수정)
      backgroundColor="default1"
      {...props}
    >
      {children}
    </Box>
  );
};
